/* eslint-disable @typescript-eslint/no-empty-function */
import Icon from "hardcover-ui/components/Icon";
import Button from "hardcover-ui/components/Button";
import LoadingSpinner from "hardcover-ui/components/LoadingSpinner";
import circlePlus from "icons/solid/circle-plus.svg";

export default function InactiveAddNewColumnButton({
  loading = false,
  onClick = () => {},
}: {
  loading?: boolean;
  onClick?: any;
}) {
  return (
    <Button variant="pill" size="sm" onClick={onClick}>
      {loading ? <LoadingSpinner size="sm" /> : <Icon icon={circlePlus} />}
      <span>Add</span>
    </Button>
  );
}
